import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import { userTypes, UserTypeContext } from "contexts/UserTypeContext";

import AdminLayout from "layouts/Admin.js";

import UserLayout from "layouts/User.js";
import PublicLayout from "layouts/Public.js";

import NotFound from "views/NotFound";

export default function RouterWrapper(prop) {
  const [user_type, setUserType] = useState(
    () => localStorage.getItem("userType") || userTypes.unAuthenticated
  );

  useEffect(() => {
    localStorage.setItem("userType", user_type);
  }, [user_type]);
  function changeType(type) {
    setUserType(type);
  }

  const userType = user_type;

  return (
    <UserTypeContext.Provider
      value={{ type: user_type, changeType: changeType }}
    >
      <BrowserRouter>
        <Routes>
          {userType === "unAuthenticated" && (
            <>
              <Route
                path="/"
                exact
                element={<Navigate to="/login" replace />}
              />
              <Route path="/*" element={<PublicLayout />} />
              <Route path="/*" element={<Navigate to="/login" replace />} />
            </>
          )}

          {userType === "admin" && (
            <>
              <Route
                path="/"
                exact
                element={<Navigate to="/admin/dashboard" replace />}
              />
              <Route path="/admin/*" element={<AdminLayout />} />
              <Route path="*" element={<Navigate to="/notfound" replace />} />
            </>
          )}

          {userType === "user" && (
            <>
              <Route
                path="/"
                element={<Navigate to="/user/dashboard" replace />}
              />
              <Route path="/user/*" element={<UserLayout />} />
              <Route path="*" element={<Navigate to="/notfound" replace />} />
            </>
          )}
          <Route path="/notfound" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </UserTypeContext.Provider>
  );
}
